import { HistoricalData } from 'dashboard409a/services/types';

export interface IRatesOfChangeProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartData: HistoricalData[];
  isLoading: boolean;
  metricOptions?: string[];
}


interface DataPoint {
  dt: string;
  [key: string]: number | string;
}

interface GPCMetric {
  default: string;
}


interface DataSetPoint {
  x: string;
  y: number;
}

interface Dataset {
  type: string;
  label: string;
  data: Array<DataSetPoint>;
  backgroundColor: string;
  borderColor: string;
  pointRadius: number;
}

interface GPCDataItem {
  ticker_symbol: string;
  color: string;
  [key: string]: {
    dt: string;
    [metricKey: string]: number | string;
  }[] | string;
}

interface DataSets {
  datasets: Dataset[];
}

export enum TimeInterval {
  MONTH_3 = 'month_3',
  MONTH_6 = 'month_6',
  YEAR_1 = 'year_1',
  YEAR_3 = 'year_3',
  YEAR_5 = 'year_5',
  YEAR_10 = 'year_10',
}

export const timeIntervals = [
  TimeInterval.MONTH_3,
  TimeInterval.MONTH_6,
  TimeInterval.YEAR_1,
  TimeInterval.YEAR_3,
  TimeInterval.YEAR_5,
  TimeInterval.YEAR_10,
];


export type { DataPoint, Dataset, DataSetPoint, DataSets, GPCDataItem, GPCMetric };

